import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import InvoiceForm from "@/pages/InvoiceForm";
import Bookings from "@/pages/Bookings";
import BookingForm from "@/pages/BookingForm";
import ETickets from "@/pages/ETickets";
import ETicketForm from "@/pages/ETicketForm";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Hotels from "@/pages/Hotels";
import VerifyEticket from "@/pages/VerifyEticket";
import Accounting from "@/pages/Accounting";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import PublicInvoice from "@/pages/PublicInvoice";
import "@/App.css";

function RequireAuth() {
  const nav = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("gg_token")) nav("/login", { replace: true });
  }, [nav]);
  return <Outlet />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/i/:id" element={<PublicInvoice />} />
        <Route path="/verify/eticket/:id" element={<VerifyEticket />} />
        <Route element={<RequireAuth />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/invoices/new" element={<InvoiceForm />} />
            <Route path="/invoices/:id" element={<InvoiceForm />} />
            <Route path="/bookings" element={<Navigate to="/etickets" replace />} />
            <Route path="/bookings/new" element={<Navigate to="/etickets/new" replace />} />
            <Route path="/etickets" element={<ETickets />} />
            <Route path="/etickets/new" element={<ETicketForm />} />
            <Route path="/etickets/upload" element={<BookingForm />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:id" element={<CustomerDetail />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/accounting" element={<Accounting />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
